<script lang="ts">
	interface Props {
		children?: import('svelte').Snippet;
	}

	let { children }: Props = $props();
</script>

<span class="bg-[var(--primary-light)]">{@render children?.()}</span>
